module.exports = __webpack_public_path__ + "static/logo-chickasaw-e0d084cfc5c845ecaa20abf24e1cb443.png";